import PriceQuotesPageLink from './PriceQuotesPageLink';

export default PriceQuotesPageLink;
